// Display-only label mapping for pipeline stages.
// Backend canonical stage names are preserved in the database and API; this map
// only changes what is rendered in the UI.
export const STAGE_LABELS = {
  "New": "New",
  "Researching": "Researching",
  "Qualified": "Qualified",
  "Contacted": "Contacted",
  "Replied": "Responded",
  "Assessment Requested": "Discovery Scheduled",
  "Assessment Delivered": "Proposal Sent",
  "Paid": "Customer",
  "Repeat Customer": "Repeat Customer",
  "Lost Opportunity": "Lost Opportunity",
};

export const stageLabel = (canonical) => STAGE_LABELS[canonical] || canonical;

// Translate canonical stage names appearing inside backend-generated activity
// description strings (e.g. "Replied → Assessment Requested" → "Responded → Discovery Scheduled")
export const translateStageDescription = (text) => {
  if (!text) return text;
  let out = text;
  for (const [canonical, label] of Object.entries(STAGE_LABELS)) {
    if (canonical !== label) {
      out = out.split(canonical).join(label);
    }
  }
  return out;
};
